// extracted by mini-css-extract-plugin
export default {"cancelButtonBody":"CancelButton_cancelButtonBody__kcr0M","cancelButtonText":"CancelButton_cancelButtonText__NV2EP"};